import { render } from "./TotalApp.vue?vue&type=template&id=07ee4d2e&scoped=true"
import script from "./TotalApp.vue?vue&type=script&lang=js"
export * from "./TotalApp.vue?vue&type=script&lang=js"

import "./TotalApp.vue?vue&type=style&index=0&id=07ee4d2e&lang=scss&scoped=true"

import exportComponent from "/Users/jason.pollock/Containers/globaltech/packages/fool-wp-commerce/vue-commerce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ee4d2e"]])

export default __exports__